export default __webpack_public_path__ + "static/media/home-banner4.b1b5feb3.png";